import DialogConfirmar from 'global/guides/Dialog/DialogConfirmar'
import { AprovarService as useService } from '../../service/aprovar'

const AprovarAjusteModal: React.FC = () => {
    const { handleSubmit, isLoading } = useService()

    return (
        <DialogConfirmar
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title="Tem certeza que deseja aprovar o ajuste?"
        />
    )
}

export default AprovarAjusteModal
